export const PERMISSION_MATRIX_COLUMNS = ["see", "create", "edit", "delete"];

export const PERMISSION_MATRIX_COLUMN_LABELS = {
  see: "Sheh",
  create: "Krijon",
  edit: "Modifikon",
  delete: "Fshin",
};

export const PERMISSION_MATRIX_CONFIG = {
  product: {
    rows: [
      {
        label: "Kategori Produkti",
        see: "can_see_product_category",
        create: "can_create_product_category",
        edit: "can_edit_product_category",
        delete: "can_delete_product_category",
      },
      {
        label: "Liste Produkte",
        see: "can_see_product",
        create: "can_create_product",
        edit: "can_edit_product",
        delete: "can_delete_product",
      },
      {
        label: "Detaje Produkti",
        see: "can_see_product_details",
      },
      {
        label: "Historik produkti",
        see: "can_see_product_history",
      },
      {
        label: "Aksesore",
        see: "can_see_product_accessory",
        create: "can_create_product_accessory",
        edit: "can_edit_product_accessory",
        delete: "can_delete_product_accessory",
      },
      {
        label: "Materiale",
        see: "can_see_product_materials",
        create: "can_create_product_materials",
        edit: "can_edit_product_materials",
        delete: "can_delete_product_materials",
      },
      {
        label: "Detaje Materialit",
        see: "can_see_material_details",
      },
      {
        label: "Sherbime",
        see: "can_see_product_services",
        create: "can_create_product_services",
        edit: "can_edit_product_services",
        delete: "can_delete_product_services",
      },
      {
        label: "Detaje Sherbimit",
        see: "can_see_service_details",
      },
    ],
  },
  attribute: {
    rows: [
      {
        label: "Atribute",
        see: "can_see_product_attributes",
        create: "can_create_product_attributes",
        edit: "can_edit_product_attributes",
        delete: "can_delete_product_attributes",
      },
    ],
  },
  supplier: {
    rows: [
      {
        label: "Liste Furnitore",
        see: "can_see_suppliers",
        create: "can_create_supplier",
        edit: "can_edit_supplier",
        delete: "can_delete_supplier",
      },
      {
        label: "Kategori",
        see: "can_see_supplier_category",
        create: "can_create_supplier_category",
        edit: "can_edit_supplier_category",
        delete: "can_delete_supplier_category",
      },
      {
        label: "Atribute",
        see: "can_see_supplier_attributes",
        create: "can_create_supplier_attributes",
        edit: "can_edit_supplier_attributes",
        delete: "can_delete_supplier_attributes",
      },
    ],
  },
  customer: {
    rows: [
      {
        label: "Liste Kliente",
        see: "can_see_customers",
        create: "can_create_customers",
        edit: "can_edit_customers",
        delete: "can_delete_customers",
      },
      {
        label: "Detaje Klientit",
        see: "can_see_customers_details",
      },
      {
        label: "Kategori",
        see: "can_see_customer_category",
        create: "can_create_customer_category",
        edit: "can_edit_customer_category",
        delete: "can_delete_customer_category",
      },
      {
        label: "Atribute",
        see: "can_see_customer_attributes",
        create: "can_create_customer_attributes",
        edit: "can_edit_customer_attributes",
        delete: "can_delete_customer_attributes",
      },
    ],
  },
  transactions: {
    rows: [
      {
        label: "Magazina",
        see: "can_see_warehouses",
        create: "can_create_warehouses",
        edit: "can_edit_warehouses",
        delete: "can_delete_warehouses",
      },
      {
        label: "Detaje Magazines",
        see: "can_see_warehouses_details",
      },
      {
        label: "Kategori Magazina",
        see: "can_see_warehouse_category",
        create: "can_create_warehouse_category",
        edit: "can_edit_warehouse_category",
        delete: "can_delete_warehouse_category",
      },
      {
        label: "Pikat e Shitjes",
        see: "can_see_pos",
        create: "can_create_pos",
        edit: "can_edit_pos",
        delete: "can_delete_pos",
      },
      {
        label: "Detaje Pik Shitjes",
        see: "can_see_pos_details",
      },
    ],
  },
  pricing: {
    rows: [
      {
        label: "Cmimet",
        see: "can_see_cmimet",
      },
      {
        label: "Oferta dhe Fushata",
        see: "can_see_oferta",
      },
      {
        label: "Kalendari i cmimeve",
        see: "can_see_calendar",
      },
    ],
  },
  draft: {
    rows: [
      {
        label: "Draft",
        see: "can_see",
        create: "can_create",
        edit: "can_edit",
        delete: "can_delete",
      },
      {
        label: "Kerkon cmim",
        create: "can_request_discount",
      },
      {
        label: "Konfirmon kerkese cmimi",
        edit: "can_confirm_discount",
      },
      {
        label: "Menaxhon draftet e te tjereve",
        edit: "can_manage_others",
      },
    ],
  },
  order: {
    rows: [
      {
        label: "Porosi",
        see: "can_see",
        create: "can_create",
        edit: "can_edit",
        delete: "can_delete",
      },
      {
        label: "Menaxhon porosite e te tjereve",
        edit: "can_manage_others",
      },
      {
        label: "Kalon porosite ne fature",
        edit: "can_invoice",
      },
    ],
  },
  stock: {
    rows: [
      {
        label: "Gjendja",
        see: "can_see",
        create: "can_create",
      },
    ],
  },
  reservations: {
    rows: [
      {
        label: "Rezervime",
        create: "can_create_reservation",
        edit: "can_edit_reservation",
      },
      {
        label: "Mbyll rezervime",
        edit: "can_close_reservations",
      },
      {
        label: "Sheh te gjithe rezervimet",
        see: "can_see_all_reservations",
      },
    ],
  },
  user_roles: {
    rows: [
      {
        label: "Perdorues",
        see: "can_see_user",
        create: "can_create_user",
        edit: "can_edit_user",
      },
      {
        label: "Role",
        see: "can_see_user_roles",
        create: "can_create_role",
        edit: "can_edit_role",
      },
      {
        label: "Te drejta",
        edit: "can_edit_permissions",
      },
      {
        label: "Pikat e shitjes",
        see: "can_see_pos",
      },
      {
        label: "Percakton perdorues ne POS",
        edit: "can_assign_pos",
      },
      {
        label: "Heq perdoruesin nga POS",
        delete: "can_delete_pos",
      },
    ],
  },
  processes: {
    rows: [
      {
        label: "Procese",
        see: "can_see",
        create: "can_create",
        edit: "can_edit",
        delete: "can_delete",
      },
    ],
  },
};

export function hasPermissionMatrix(moduleName) {
  return Object.prototype.hasOwnProperty.call(PERMISSION_MATRIX_CONFIG, moduleName);
}

export const PRODUCT_ATTRIBUTE_PERMISSION_NAMES = [
  "can_see_product_attributes",
  "can_create_product_attributes",
  "can_edit_product_attributes",
  "can_delete_product_attributes",
];

export function visiblePermissionNames(moduleName) {
  const config = PERMISSION_MATRIX_CONFIG[moduleName];
  if (!config) return null;
  const names = new Set();
  config.rows.forEach((row) => {
    PERMISSION_MATRIX_COLUMNS.forEach((column) => {
      if (row[column]) names.add(row[column]);
    });
  });
  return names;
}

export function injectStandaloneAttributeModule(modules) {
  const out = [];
  (modules || []).forEach((mod) => {
    out.push(mod);
    if (mod.module_name !== "product") return;
    const permissions = PRODUCT_ATTRIBUTE_PERMISSION_NAMES.map((name) =>
      (mod.permissions || []).find((permission) => permission.name === name)
    ).filter(Boolean);
    if (!permissions.length) return;
    out.push({
      id: 0,
      module_name: "attribute",
      module_title: "Atribute",
      is_collapsed: true,
      virtual: true,
      permissions,
    });
  });
  return out;
}
